import React, { useRef } from 'react';
import { WidgetLayout } from '../shared/WidgetLayout/WidgetLayout';
import { Box, Radio, Text } from '@wix/design-system';
import { CardLayout } from '../shared/CardLayout/CardLayout';
import s from './RadioButtonWidget.module.scss';
import { generateId } from '../shared/utils';
import { useDisabledWidget } from '../../../shared/disabled-widget/useDisabledWidget';
import { WithDisabledControl } from '../../../shared/disabled-widget/WithDisabledControl';
export const RadioButtonWidget = _ref => {
  var _find, _data$secondaryButton, _data$primaryButton;
  let {
    data,
    context,
    config
  } = _ref;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const widgetId = useRef(generateId());
  const [selectedValue, setSelectedValue] = React.useState('');
  const selectedTitle = ((_find = (data.options ?? []).find(_ref2 => {
    let {
      value
    } = _ref2;
    return value === selectedValue;
  })) == null ? void 0 : _find.title) ?? '';
  const handleButtonClick = function (action, label) {
    if (label === void 0) {
      label = '';
    }
    const handler = effects => {
      const onWidgetActionData = {
        action,
        value: {
          label,
          effects
        }
      };
      context.onWidgetAction(RADIO_BUTTON_WIDGET, onWidgetActionData, data.text);
    };
    return handler;
  };
  const handleRadioClick = (value, label) => {
    setSelectedValue(value);
    const onWidgetActionData = {
      action: 'radio_button_select',
      value: {
        value,
        label
      }
    };
    context.onWidgetAction(RADIO_BUTTON_WIDGET, onWidgetActionData, data.text);
  };
  const cards = (data.options ?? []).map(_ref3 => {
    let {
      title,
      text,
      value
    } = _ref3;
    return /*#__PURE__*/React.createElement(CardLayout, {
      key: value
    }, /*#__PURE__*/React.createElement(Box, {
      align: "space-between",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(WithDisabledControl, {
      isDisabled: areControlsDisabled,
      onEnable: enableControls,
      t: context.t
    }, /*#__PURE__*/React.createElement(Radio, {
      id: `${widgetId.current}-${value}`,
      checked: selectedValue === value,
      onChange: () => {
        handleRadioClick(value, title);
      },
      label: /*#__PURE__*/React.createElement("div", {
        className: s.optionLabel,
        onClick: () => {
          handleRadioClick(value, title);
        }
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }, title)),
      disabled: areControlsDisabled
    }))), text && /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, text));
  });
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    text: data.text,
    secondaryButton: data.secondaryButton,
    primaryButton: data.primaryButton,
    context: context,
    selectedValues: [selectedValue],
    selectedTitles: [selectedTitle],
    onSecondaryButtonClick: handleButtonClick('secondary_button_click', (_data$secondaryButton = data.secondaryButton) == null ? void 0 : _data$secondaryButton.label),
    onPrimaryButtonClick: handleButtonClick('primary_button_click', (_data$primaryButton = data.primaryButton) == null ? void 0 : _data$primaryButton.label),
    footerButtonsAsColumn: data.footerButtonsAsColumn,
    bottomText: data.bottomText,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, !!cards.length && cards);
};
export const RADIO_BUTTON_WIDGET = 'RADIO_BUTTON_WIDGET';
//# sourceMappingURL=RadioButtonWidget.js.map